import { Navigate } from "react-router-dom";
import { useAuth } from "hooks/useAuth";

interface PublicRouteProps {
  children: any;
  redirect?: boolean;
}

function PublicRoute({ children, redirect }: PublicRouteProps) {
  if (redirect === undefined || redirect === true) {
    const { user } = useAuth();
    return !user ? children : <Navigate to="/home" />;
  }
  else {
    return children;
  }
  
}

export default PublicRoute;
